import React from "react";
import { Link } from "react-scroll";
import ContactButton from "./ContactButton.jsx";


export default function Home() {
  return (
    <section
      className="hero sticky bottom-0  bg-[url('/herobg.webp')] sm:h-screen text-center pt-20 bg-cover bg-center"

    >
      <div className="container h-full py-20 flex flex-col  justify-around mx-auto px-4 ">
        <div className="flex flex-col items-center">
          <h1 className="h1 font-semibold mb-4">
            Лапшина Ирина Анатольевна — частный юрист
          </h1>
          <p className="h2 mb-6  border border-white py-3 px-6 rounded-full hover:text-gray-900 transition">
            Работа с физическими и юридическими лицами
          </p>
        </div>

        <div className="flex  flex-col md:gap-26 md:flex-row  justify-between mt-8 text-left">
          <article>
            <h2 className="h2 mb-2">Специализация:</h2>
            <ul className="list-disc text3 list-inside">
              <li>Гражданско-правовые споры</li>
              <li>Защита прав потребителей</li>
              <li>Страховые споры</li>
              <li>Защита прав собственности</li>
              <li>Помощь в приобретении недвижимости</li>
              <li>Помощь в приватизации собственности</li>
              <li>Составление договоров</li>
            </ul>
          </article>

          <article>
            <h2 className="h2 mb-2">Контакты:</h2>
            <address className="list-disc text3 list-inside">
              <li>Адрес: г. Наро-Фоминск, ул. Полубоярова, д.8</li>
              <li>Время работы: Пн-Пт – с 10:00 до 18:00 По предварительной записи</li>
              <li>Телефон: +7 916 332 82 59</li>
              <li>E-mail: laptshka@mail.ru</li>
            </address>
          </article>
        </div>

   <ContactButton></ContactButton>
      </div>
    </section>
  );
}
